import React from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';

class EchartBar extends React.Component {
    state = {
        myChart: {},
    }
    // 从拿到的data中获取legend
    getlegendArray = (data) => {
        let legendArray = [];
        for (let i = 0; i < data.length; i++) {
            legendArray.push(data[i].name);
        }
        return legendArray;
    }

    // // 首次加载初始化视图
    // componentDidMount() {
    //     this.initChart();
    // };
    componentDidMount() {
        // this.initChart();
        this.props.initChart(this.initChart);
    }
    componentWillUnmount() {
        //一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.handleResize, false);
    }
    handleResize = e => {
        this.state.myChart.resize();
    }
    initChart = () => {
        let myChart = echarts.init(document.getElementById(this.props.echartId));
        let option = {
            title: {
                text: this.props.title,
                textAlign: 'auto',
                x: 'center',
                y: 'top',
                textStyle: {
                    color: '#000',
                },
            },
            tooltip: {
                show: false,
                trigger: 'axis'
            },
            legend: {
                data: this.getlegendArray(this.props.echartData.listData) ,
                orient: 'vertical',
                left: 'center',
                bottom: 'bottom',
                textStyle: {
                    color: '#000',
                },
            },
            toolbox: {
                show: false,
                feature: {
                    dataZoom: {},
                    dataView: {
                        readOnly: false
                    },
                    magicType: {
                        type: ['line']
                    },
                    restore: {},
                    saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: this.props.echartData.xSeries,
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#333'
                    },
                    interval:0  // 控制x轴是否隔一个显示，0：显示，1：隔一个显示
                },
                axisLine: {
                    lineStyle: {
                        color: '#333',
                        width: 1,   //这里是为了突出显示加上的  
                    }
                },
                splitLine: {
                    show: false
                },
            },
            yAxis: {
                name:"单位：万元",
                type: 'value',
                axisLabel: {
                    formatter: '{value} ',
                    textStyle: {
                        color: '#333'
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: '#333',
                        width: 1,   //这里是为了突出显示加上的  
                    }
                },
                splitLine: {
                    show: false
                }
            },
            series: this.props.echartData.listData
        };
        myChart.setOption(option);
        this.setState({ myChart: myChart });
        window.addEventListener('resize', this.handleResize, false);
    }

    render() {
        return (
            <div id={this.props.echartId} style={{ width: '100%', height: '100%' }}></div>
        )
    }
}

export { EchartBar }
